<div class="flex flex-col gap-2">
  <p class="text-sm text-shikenso-purple-base-60 mb-3" data-testid="campaign-details-kpi-goals-description">
    {{ 'pages.campaignDetails.kpiGoals.description' | translate }}
  </p>

  <span class="text-sm mb-1">
    {{ 'pages.campaignDetails.kpiGoals.filters.title' | translate }}
  </span>

  <div class="flex flex-wrap items-center gap-4 pl-1">
    <app-campaign-details-deliverables-filter-select
      class="w-[252px]"
      [emptyLabel]="ctaTemplateEmptyLabel()"
      [loading]="isContentLoading()"
      [options]="filterOptions().ctaTemplateNames"
      [searchPlaceholder]="'pages.campaignDetails.kpiGoals.filters.searchDeliverableGroup' | translate"
      [selectedValues]="filterState().ctaTemplateNames"
      (selectionChanged)="onCtaTemplateNamesChanged($event)"
    />

    <app-campaign-details-deliverables-filter-select
      class="w-[252px]"
      [emptyLabel]="kpiTypeEmptyLabel()"
      [loading]="isContentLoading()"
      [options]="filterOptions().kpiTypes"
      [searchPlaceholder]="'pages.campaignDetails.kpiGoals.filters.searchKpiType' | translate"
      [selectedValues]="filterState().kpiTypes"
      (selectionChanged)="onKpiTypesChanged($event)"
    />
  </div>

  <div class="flex flex-col overflow-hidden w-full pl-2 mb-1">
    <div
      class="flex items-center"
      [class.justify-between]="campaignExportConfig().showKpiGoalsStatusFilter"
      [class.justify-end]="!campaignExportConfig().showKpiGoalsStatusFilter"
    >
      @if (campaignExportConfig().showKpiGoalsStatusFilter) {
        <div class="flex items-center gap-6">
          <span class="text-xs text-shikenso-purple-base-60">
            {{ 'pages.campaignDetails.kpiGoals.filters.kpiGoalStatus' | translate }}
          </span>

          <app-campaign-details-deliverables-status-filters
            [loaderCount]="3"
            [loading]="isContentLoading()"
            [selectedStatuses]="filterState().statuses"
            [statusOptions]="visibleStatusOptions()"
            (selectedStatusesChanged)="onStatusesChanged($event)"
          />
        </div>
      }

      <app-campaign-details-deliverables-group-toggle
        [checked]="groupByContent()"
        (checkedChanged)="onGroupByContentChanged($event)"
      />
    </div>

    @if (filteredCreator()) {
      <app-filtered-creator-badge
        [creatorIcon]="filteredCreator()!.icon"
        [creatorName]="filteredCreator()!.name"
        (removed)="filteredCreatorRemoved.emit()"
      />
    }
  </div>

  <app-campaign-details-kpi-goals-table
    [campaignExportConfig]="campaignExportConfig()"
    [groupedMode]="groupByContent()"
    [groupedRowData]="groupedRows()"
    [loading]="isContentLoading()"
    [rowData]="filteredRows()"
    (groupedRowGroupClicked)="onKpiGoalsRowGroupClicked($event)"
    (rowClicked)="onKpiGoalsRowClicked($event)"
  />
</div>
